/**
 * Nice Cube storefront enhancements.
 * Dependency-free and scoped to Shopify product sections.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Currency && typeof window.Currency.formatMoney === 'function') {
      return window.Currency.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}');
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateBundlePrices(selector, unitPrice) {
    if (!selector) return;
    selector.setAttribute('data-unit-price', unitPrice);

    var options = selector.querySelectorAll('[data-bundle-option]');
    for (var i = 0; i < options.length; i += 1) {
      var option = options[i];
      var quantity = parseInt(option.getAttribute('data-quantity'), 10) || 1;
      var discount = parseInt(option.getAttribute('data-discount'), 10) || 0;
      var compareTotal = unitPrice * quantity;
      var total = Math.round(compareTotal * (100 - discount) / 100);
      var price = option.querySelector('[data-bundle-price]');
      var compare = option.querySelector('[data-bundle-compare]');
      var save = option.querySelector('[data-bundle-save]');

      if (price) price.textContent = formatMoney(total);
      if (compare) {
        compare.textContent = formatMoney(compareTotal);
        compare.hidden = discount <= 0;
      }
      if (save) {
        save.textContent = discount > 0 ? 'Save ' + discount + '%' : '';
        save.hidden = discount <= 0;
      }
    }
  }

  function initBundleSelector(productSection) {
    var selector = productSection.querySelector('[data-bundle-selector]');
    if (!selector || selector.getAttribute('data-bundle-ready') === 'true') return;
    selector.setAttribute('data-bundle-ready', 'true');

    var form = selector.closest('form.ProductForm');
    if (!form) return;

    var quantityInput = form.querySelector('input[name="quantity"]');
    var options = selector.querySelectorAll('[data-bundle-option]');
    var initialUnitPrice = parseInt(selector.getAttribute('data-unit-price'), 10) || 0;
    updateBundlePrices(selector, initialUnitPrice);

    function markSelected(button) {
      for (var i = 0; i < options.length; i += 1) {
        var isSelected = options[i] === button;
        options[i].classList.toggle('is-selected', isSelected);
        options[i].setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      }
    }

    for (var i = 0; i < options.length; i += 1) {
      options[i].addEventListener('click', function () {
        var quantity = parseInt(this.getAttribute('data-quantity'), 10) || 1;
        markSelected(this);
        if (quantityInput) {
          quantityInput.value = quantity;
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function syncFromQuantity() {
      if (!quantityInput) return;
      var value = parseInt(quantityInput.value, 10) || 1;
      var match = null;
      for (var i = 0; i < options.length; i += 1) {
        if ((parseInt(options[i].getAttribute('data-quantity'), 10) || 1) === value) {
          match = options[i];
          break;
        }
      }
      if (match) markSelected(match);
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', syncFromQuantity);
      quantityInput.addEventListener('input', syncFromQuantity);
    }
  }

  function initProductSection(productSection) {
    if (!productSection || productSection.getAttribute('data-store-enhanced') === 'true') return;
    productSection.setAttribute('data-store-enhanced', 'true');

    var saleBadge = productSection.querySelector('[data-sale-badge]');
    var salePercentage = productSection.querySelector('[data-sale-percentage]');
    var stockStatus = productSection.querySelector('[data-stock-status]');
    var stockLabel = productSection.querySelector('[data-stock-label]');
    var stickyBar = productSection.querySelector('[data-product-sticky-bar]');
    var mainButton = productSection.querySelector('.ProductForm__AddToCart');
    var stickyButton = stickyBar ? stickyBar.querySelector('[data-sticky-add]') : null;
    var stickyLabel = stickyBar ? stickyBar.querySelector('[data-sticky-label]') : null;
    var stickyPrice = stickyBar ? stickyBar.querySelector('[data-sticky-price]') : null;
    var buyNowButton = productSection.querySelector('[data-direct-checkout]');
    var bundleSelector = productSection.querySelector('[data-bundle-selector]');

    initBundleSelector(productSection);

    function syncVariantIndicators(variant) {
      if (!variant) {
        if (saleBadge) saleBadge.hidden = true;
        if (stockStatus) stockStatus.hidden = true;
        return;
      }

      var isOnSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
      if (saleBadge) saleBadge.hidden = !isOnSale;
      if (salePercentage && isOnSale) {
        salePercentage.textContent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      }

      if (stockStatus) {
        stockStatus.hidden = false;
        stockStatus.classList.toggle('is-unavailable', !variant.available);
      }
      if (stockLabel) stockLabel.textContent = variant.available ? 'In stock' : 'Sold out';
      if (stickyButton) stickyButton.disabled = !variant.available;
      if (buyNowButton) buyNowButton.disabled = !variant.available;
      if (bundleSelector) updateBundlePrices(bundleSelector, variant.price);
    }

    function syncStickyBar() {
      if (!stickyBar || !mainButton || !stickyButton) return;
      var mainLabel = mainButton.querySelector('span:first-child');
      var mainPrice = mainButton.querySelector('[data-money-convertible]');
      var metaPrice = productSection.querySelector('.ProductMeta__PriceList .Price:not(.Price--compareAt)');
      stickyButton.disabled = mainButton.disabled;
      if (stickyLabel && mainLabel) stickyLabel.textContent = mainLabel.textContent.trim();
      if (stickyPrice) {
        var priceSource = mainPrice || metaPrice;
        if (priceSource) stickyPrice.textContent = priceSource.textContent.trim();
      }
    }

    function setStickyVisible(isVisible) {
      if (!stickyBar) return;
      stickyBar.classList.toggle('is-visible', isVisible);
      stickyBar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    function handleVariantChanged(event) {
      syncVariantIndicators(event.detail && event.detail.variant);
      window.requestAnimationFrame(syncStickyBar);
      window.setTimeout(syncStickyBar, 80);
    }

    document.addEventListener('variant:changed', handleVariantChanged);

    if (!stickyBar || !mainButton || !stickyButton) return;

    stickyButton.addEventListener('click', function () {
      if (!mainButton.disabled) mainButton.click();
    });

    document.addEventListener('product:added', function () {
      setStickyVisible(false);
    });

    syncStickyBar();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setStickyVisible(!entry.isIntersecting && window.pageYOffset > 260);
      }, { threshold: 0.12 });
      observer.observe(mainButton);
    } else {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var rect = mainButton.getBoundingClientRect();
          setStickyVisible(rect.bottom < 0 && window.pageYOffset > 260);
          ticking = false;
        });
      }, { passive: true });
    }
  }


  function initReels(root) {
    var context = root || document;
    var sliders = context.querySelectorAll ? context.querySelectorAll('[data-reels-slider]') : [];

    for (var i = 0; i < sliders.length; i += 1) {
      var slider = sliders[i];
      if (slider.getAttribute('data-reels-ready') === 'true') continue;
      slider.setAttribute('data-reels-ready', 'true');

      var section = slider.closest('.NeedohReels');
      var track = slider.querySelector('[data-reels-track]');
      var prev = section ? section.querySelector('[data-reels-prev]') : null;
      var next = section ? section.querySelector('[data-reels-next]') : null;

      function scrollFromButton(button, direction) {
        var reelSection = button ? button.closest('.NeedohReels') : null;
        var reelTrack = reelSection ? reelSection.querySelector('[data-reels-track]') : null;
        if (!reelTrack) return;
        var amount = Math.max(240, Math.min(reelTrack.clientWidth * 0.78, 620));
        reelTrack.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollFromButton(this, -1); });
      if (next) next.addEventListener('click', function () { scrollFromButton(this, 1); });
    }

    if (document.documentElement.getAttribute('data-reel-play-ready') !== 'true') {
      document.documentElement.setAttribute('data-reel-play-ready', 'true');
      document.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-reel-play]') : null;
        if (!button) return;
        var card = button.closest('[data-reel-card]');
        var video = card ? card.querySelector('video') : null;
        if (!video) return;
        event.preventDefault();

        if (video.paused) {
          var otherVideos = document.querySelectorAll('.NeedohReels video');
          for (var j = 0; j < otherVideos.length; j += 1) {
            if (otherVideos[j] !== video && !otherVideos[j].paused) {
              otherVideos[j].pause();
              var otherCard = otherVideos[j].closest('[data-reel-card]');
              if (otherCard) otherCard.classList.remove('is-playing');
            }
          }
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
          if (card) card.classList.add('is-playing');
        } else {
          video.pause();
          if (card) card.classList.remove('is-playing');
        }
      });
    }
  }

  function initAllProductSections(root) {
    var context = root || document;
    var sections = context.querySelectorAll ? context.querySelectorAll('.Product--conversionOptimized[data-section-type="product"]') : [];
    for (var i = 0; i < sections.length; i += 1) initProductSection(sections[i]);
    if (context.matches && context.matches('.Product--conversionOptimized[data-section-type="product"]')) initProductSection(context);
  }

  function initDirectCheckout() {
    if (document.documentElement.getAttribute('data-direct-checkout-ready') === 'true') return;
    document.documentElement.setAttribute('data-direct-checkout-ready', 'true');

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-direct-checkout]') : null;
      if (!button || button.disabled) return;
      var form = button.closest('form.ProductForm');
      if (!form) return;

      event.preventDefault();
      var label = button.querySelector('[data-direct-checkout-label]');
      var originalLabel = label ? label.textContent : 'Buy now';
      button.disabled = true;
      button.classList.add('is-loading');
      if (label) label.textContent = 'Opening checkout…';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var formData = new FormData(form);

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to add item');
        return response.json();
      }).then(function () {
        window.location.href = root + 'checkout';
      }).catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (label) label.textContent = originalLabel;
        window.location.href = root + 'cart';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllProductSections(document);
      initDirectCheckout();
      initReels(document);
    });
  } else {
    initAllProductSections(document);
    initDirectCheckout();
    initReels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllProductSections(event.target);
    initReels(event.target);
  });
}());
